'use strict';

/*global $:true */
angular
    .module('xx-http-error-handling', [])
    .config(function($httpProvider, $compileProvider) {
        var elementsList = $();

        var showMessage = function(content, cl, time) {
            $('<div/>')
                .addClass('alert')
                .addClass('alert-dismissable')
                .addClass(cl)
                .hide()
                .fadeIn('fast')
                .delay(time)
                .fadeOut('fast', function() { $(this).remove(); })
                .appendTo(elementsList)
                .text(content);
        };
        $httpProvider.interceptors.push(function($q) {
            return function(promise) {
                return promise.then(function(successResponse) {
                    return successResponse;

                }, function(errorResponse) {
                    switch (errorResponse.status) {
                        case 401:
                            showMessage('Wrong usename or password', 'alert-danger', 15000);
                            break;
                        case 403:
                            showMessage('You don\'t have the right to do this', 'alert-danger', 15000);
                            break;
                        case 500:
                            showMessage('Server internal error: ' + errorResponse.data, 'alert-danger', 15000);
                            break;
                        default:
                            showMessage('Server error encountered. Possible connection lost.', 'alert-danger', 15000);
                    }
                    return $q.reject(errorResponse);
                });
            };
        });

        $compileProvider.directive('appMessages', function() {
            var directiveDefinitionObject = {
                link: function(scope, element, attrs) { elementsList.push($(element)); }
            };
            return directiveDefinitionObject;
        });
    });
